import { ReactElement, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import InlineLink from '@/components/InlineLink'
import Button from '@/components/Button'

import ScrollLink from '@/lib/scroll'
import { logEvent } from '@/lib/gtm'

import { ReactComponent as Group13 } from '@/svg/decorators/group-13.svg'
import { ReactComponent as Group22 } from '@/svg/decorators/group-22.svg'
import { ReactComponent as Group29 } from '@/svg/decorators/group-29.svg'
import { ReactComponent as Group1 } from '@/svg/decorators/group-1.svg'
import { ReactComponent as Group2 } from '@/svg/decorators/group-2.svg'

import ImageFile from '@/png/landing/businessman-working-stacks-paper-searching-information-work-desk-office.jpg'

import { common } from '@/features/landing/constants'
import { whatIsProKitRoute } from '@/routes'
import env from '@/lib/env'

import Container from './style'

interface Props {
  style?: CSSProperties
  className?: string
  id?: string
}

function TopPane({ id, className, style }: Props): ReactElement {
  return (
    <Container id={id} className={className} style={style}>
      <div className="decorator-container">
        <div id="top-pane-image"></div>
        <div className="rectangle-container">
          <article id="top-pane-image-2-container">
            <figure id="top-pane-image-2">
              <Image
                alt="partnership-two-business-people-shaking"
                src={ImageFile}
                layout="fill"
                objectFit="cover"
              />
            </figure>
          </article>
          <section>
            <Group2 id="group-2" />
            <Group1 id="group-1" />
          </section>
        </div>
        <Group13 id="group-13" />
        <Group22 id="group-22" />
        <Group29 id="group-29" />
      </div>
      <div className="container">
        <h1>
          ปฏิบัติตาม <span className="primary">PDPA</span> <br />
          ได้อย่างครบถ้วนจบในที่เดียว{' '}
        </h1>
        <h2>
          ด้วยเอกสารและคู่มือ
          <br />
          จากผู้เชี่ยวชาญด้านกฎหมาย PDPA
        </h2>
        <section className="widget-container">
          <figure>
            <div className="widget-background"></div>
          </figure>
          <article>
            <section className="form-container">
              <p className="secondary large">พิเศษ!</p>
              <p className="secondary small">
                ซื้อชุดเอกสาร PDPA&nbsp;Prokit วันนี้
              </p>
              <p className="primary large">ราคา {common.price} เท่านั้น </p>
              <a
                href={env.PLATFORM_URL}
                target="_blank"
                rel="noreferrer"
                className="platform-link"
              >
                <Button
                  isPrimary={true}
                  usePrimaryColor={true}
                  onPress={() => {
                    logEvent({
                      category: 'Landing Page',
                      action: 'Click Purchase',
                    })
                  }}
                >
                  ซื้อชุดเอกสาร
                </Button>
              </a>
              <ScrollLink url={whatIsProKitRoute}>
                <InlineLink
                  defaultWithUnderline={true}
                  className="more-info-link"
                >
                  ดูข้อมูลเพิ่มเติม
                </InlineLink>
              </ScrollLink>
            </section>
          </article>
        </section>
      </div>
    </Container>
  )
}

TopPane.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

TopPane.defaultProps = {
  className: '',
}

export default memo(TopPane)
